import { Grid, Paper, } from "@mui/material";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

import { IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE } from "../../../constants/signalRequestConsts";
import { searchInMyChargeEmployeesDocuments, setInMyChargeEmployeeDocumentsReset } from "../../../store/slices/userRequests";
import TableDocuments from "./TableDocuments";
import MySnackbar from "../../../components/MySnackbar";
import MySelectCompany from "../../../components/MySelectCompany";

// viewType = All, InMyCharge, ToApprove

const ManagementEmployeesDocuments = ({viewType}: {viewType: "All" | "InMyCharge" | "ToApprove"}) => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [rucSelected, setRucSelected] = useState<string>("")
    const [errorMsg, setErrorMsg] = useState<string>("")

    const [employeesCodes, setEmployeesCodes] = useState<string | null>(null)
    const [descriptionOne, setDescriptionOne] = useState<string>("")
    const [pageSizeOne, setPageSizeOne] = useState<number>(25)
    const [pageOne, setPageOne] = useState<number>(2)
    
    // const [orderedEmployees, setOrderedEmployees] = useState<{ [key: string]: Employee[] }>({})

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || !connectionId) {
            return;
        }
        getInitialTablesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, connectionId]);

    
    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableOneRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionOne, pageSizeOne, pageOne, employeesCodes]);
    

    const getInitialTablesData = async () => {

        let _employeesCodes =  "";
        dispatch(setInMyChargeEmployeeDocumentsReset(IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE));
        setEmployeesCodes(_employeesCodes);
    }

    const tableOneRequest = () => 
        dispatch(searchInMyChargeEmployeesDocuments(
            IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE,
            rucSelected,
            employeesCodes as any,
            1,
            descriptionOne,
            pageSizeOne,
            pageOne,
        ));

    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "2rem 1.5rem"
            }}
        >
            <MySelectCompany
                setRucSelected={setRucSelected} 
                rucSelected={rucSelected}
                includeAllCompaniesOption={true}
                allCompaniesOptionValue={'all'}
            />
            <TableDocuments 
                rucEmpresa={rucSelected}
                requestId={IN_MY_CHARGE_EMPLOYEES_DOCUMENTS_ONE}
                page={pageOne}
                setPage={setPageOne}
                description={descriptionOne}
                setDescription={setDescriptionOne}
                pageSize={pageSizeOne}
                setPageSize={setPageSizeOne}
            />
        </Paper>
        {errorMsg && <MySnackbar
            msg={errorMsg}
            severity={"error"}
            open={!!errorMsg}
            onClose={() => {
                setErrorMsg("");
            }}
        />}
    </Grid>)
}

export default ManagementEmployeesDocuments;